import React from 'react';
import Modal from './Modal';
import './SelectLocationModal.scss';
import { Address } from '../../types/orderTypes';
import SelectLocationContent from './SelectLocationContent';
interface Props {
  onCloseModal: () => void;
  onLocationSelected: (longitude: number, latitude: number) => void;
  onAddressSelected: (newAddress: Address) => void;
  longitude: number;
  latitude: number;
  targetAddress: string;
}

interface State {
  longitude: number;
  latitude: number;
  searchAddressResult: Address | null;
  searchAddressFound: string | null;
}
export default class SelectLocationModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      longitude: this.props.longitude,
      latitude: this.props.latitude,
      searchAddressResult: null,
      searchAddressFound: null,
    };

    this.escFunction = this.escFunction.bind(this);
  }
  escFunction(event) {
    if (event.keyCode === 27) {
      this.props.onCloseModal();
    }
  }

  componentDidMount() {
    document.addEventListener('keydown', this.escFunction, false);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.escFunction, false);
  }

  render() {
    const width = 1200;

    return (
      <Modal
        title="Select A New Address Location"
        onClose={() => this.props.onCloseModal()}
        isLoading={false}
        width={width}
        buttons={[
          {
            title: 'Replace with address found',
            type: 'success',
            disabled: !this.state.searchAddressFound,
            onClick: () => {
              this.props.onAddressSelected(this.state.searchAddressResult);
            },
          },
          {
            title: 'Use location in map',
            type: 'default',
            onClick: () => {
              this.props.onLocationSelected(
                this.state.longitude,
                this.state.latitude
              );
            },
          },
        ]}
      >
        <SelectLocationContent
          longitude={this.props.longitude}
          latitude={this.props.latitude}
          targetAddress={this.props.targetAddress}
          updateLongitude={(lng: number) => {
            this.setState({ longitude: lng });
          }}
          updateLatitude={(lat: number) => {
            this.setState({ latitude: lat });
          }}
          updateSearchAddressResult={(value: Address | null) => {
            this.setState({ searchAddressResult: value });
          }}
          updateSearchAddressFound={(value: string | null) => {
            this.setState({ searchAddressFound: value });
          }}
        />
      </Modal>
    );
  }
}
